module.exports = {
  REAL_ESTATE: 'real estate', // planet, moon, orbital platform
  RESOURCE: 'natural resource', // asteroid, water deposit
  CORRIDOR: 'corridor', // Network connection
  RELATIONSHIP: 'relationship', // trade route, etc.
  VEHICLE: 'vehicle', // starship, etc.
  DISTINCTION: 'distinction', // awards
};
